import * as actions from '~/actions/vcPageActions';

const defaultState = {
  shouldShowVeracodePage: true,
};

const vcPageState = (state = defaultState, action) => {
  switch (action.type) {
    case actions.UPDATE_VC_PAGE_VISIBILITY:
      return {
        ...state,
        shouldShowVeracodePage: action.isVisible,
      };
    default:
      return state;
  }
};

export default vcPageState;
